import { StatusChipVariant } from '@occc-app/design-system';
import { AudienceBroadcastMessageStatus } from '@occc/graphql';

import { routeCreator } from '../../messaging-center.utils';
import {
  PAGE_TITLE as BASE_PAGE_TITLE,
  CAMPAIGN_LIST_PAGE_TITLE,
} from '../../messaging-center.constants';

export const breadcrumbLinks = [
  { to: routeCreator.base(), label: BASE_PAGE_TITLE },
  { to: routeCreator.campaignsList(), label: CAMPAIGN_LIST_PAGE_TITLE },
];

export const archivableStatuses: AudienceBroadcastMessageStatus[] = [
  AudienceBroadcastMessageStatus.Sent,
  AudienceBroadcastMessageStatus.Draft,
  AudienceBroadcastMessageStatus.Scheduled,
  AudienceBroadcastMessageStatus.Failed,
];

export const titleByStatus: Record<AudienceBroadcastMessageStatus, string> = {
  [AudienceBroadcastMessageStatus.Draft]: 'Draft',
  [AudienceBroadcastMessageStatus.Scheduled]: 'Scheduled',
  [AudienceBroadcastMessageStatus.Processing]: 'Processing',
  [AudienceBroadcastMessageStatus.Sent]: 'Sent',
  [AudienceBroadcastMessageStatus.Failed]: 'Failed',
  [AudienceBroadcastMessageStatus.Archived]: 'Archived',
};

export const chipVariantByStatus: Record<AudienceBroadcastMessageStatus, StatusChipVariant> = {
  [AudienceBroadcastMessageStatus.Draft]: 'warning',
  [AudienceBroadcastMessageStatus.Scheduled]: 'info',
  [AudienceBroadcastMessageStatus.Processing]: 'warning',
  [AudienceBroadcastMessageStatus.Sent]: 'success',
  [AudienceBroadcastMessageStatus.Failed]: 'error',
  [AudienceBroadcastMessageStatus.Archived]: 'default',
};
export const notArchivedStatuses = Object.values(AudienceBroadcastMessageStatus).filter(
  (status) => status !== AudienceBroadcastMessageStatus.Archived,
);

export const statusDescription: Record<AudienceBroadcastMessageStatus, string> = {
  [AudienceBroadcastMessageStatus.Sent]: 'Sent - Campaign has been sent and cannot be edited.',
  [AudienceBroadcastMessageStatus.Draft]: 'Draft - Campaign is created but not scheduled.',
  [AudienceBroadcastMessageStatus.Failed]:
    'Failed - Campaign failed to send due to a technical error.',
  [AudienceBroadcastMessageStatus.Scheduled]: 'Scheduled - Campaign is scheduled to be sent.',
  [AudienceBroadcastMessageStatus.Archived]: 'Archived - Campaign has been archived.',
  [AudienceBroadcastMessageStatus.Processing]:
    'Processing - Campaign is being processed and cannot be edited.',
};
